import { Component, HostListener } from '@angular/core';
import { Headers, Http, RequestOptions, ResponseContentType } from '@angular/http';
import { Router, ActivatedRoute, ParamMap } from '@angular/router';
import { Lightbox } from 'ngx-lightbox';
import { of } from 'rxjs';
import { NewVersionService } from './services/new-version.service';

declare var $: any;

@Component({
  templateUrl: './detailsv2.component.html',
  styleUrls: ['./detailsv2.component.css']
})

export class DetailsV2Component {

  continentFriendlyUrl: string = "europe";
  continent: any = null;
  lists: any = null;
  listTypes: any[] = [];
  languages: any[] = [];
  data: any = null;

  originalListRestaurants0: any = null;
  filterValues = {
    name: '',
    chef: '',
    cuisine: '',
    location1: '',
    location2: ''
  };
  listRestaurants0: any = null;
  listRestaurants1: any = null;
  listRestaurants2: any = null;
  listRestaurants3: any = null;
  legacyRestaurant: any = null;

  selectedListId: number = 0;
  selectedList: any = null;
  selectedLanguage: any = {};
  cardViewSelected: boolean = true;
  isSticky: boolean = false;
  isScrollDown: boolean = false;
  isFiltersShown: boolean = false;

  currentPosition: any;
  startPosition: number;

  yearFilter: any = [];
  selectedYear = 2021;

  sortByFilter: any = [
    { value: 1, displayName: "Rank", urlValue: 'rank' },
    { value: 2, displayName: "Restaurant", urlValue: 'restaurant' },
    { value: 3, displayName: "Chef", urlValue: 'chef' },
    { value: 4, displayName: "Cuisine", urlValue: 'cuisine' },
  ];

  webProjectPath: string;

  selectedSortByFilter: number[] = [1, 1, 1];

  //let's keep this on default ascending sorting
  sortByDirection: string = 'ASC'

  listFriendlyUrl = 'top100';
  listType: any = null;
  mobile = false;
  previewGuid: any = null;

  constructor(private _http: Http,
    private router: Router,
    private _lightbox: Lightbox,
    private route: ActivatedRoute,
    private newVersionService: NewVersionService) {
  }


  @HostListener('window:scroll', ['$event'])
  checkScroll() {
    let headerHeight = document.getElementById("myHeader").offsetHeight;
    this.isSticky = window.pageYOffset >= headerHeight;

    this.startPosition = window.pageYOffset;
    let scroll = window.pageYOffset;
    if (scroll > this.currentPosition) {
      this.isScrollDown = true;
    } else {
      this.isScrollDown = false;
    }
    this.currentPosition = scroll;
  }

  @HostListener('window:resize', ['$event'])
  onResize(event) {

    //var $tabNavSlider = $('.tabs .tabs__nav ul');
    //var $win = $(window);

    //var tabNavSliderOptions = {
    //  dots: false,
    //  infinite: true,
    //  slidesToShow: 1,
    //  //slidesToScroll: 1,
    //  arrows: true,
    //  //autoplay: false,
    //  //speed: 500,
    //  //variableWidth: true
    //  adaptiveHeight: true,
    //  responsive: [
    //      {
    //          breakpoint: 768,
    //          settings: {
    //              slidesToShow: 1,
    //              infinite: true,
    //              dots: false
    //          }
    //      },
    //  ]
    //};

    //this.initSlider($tabNavSlider, tabNavSliderOptions);

    //$tabNavSlider.find('.slick-slide').on('click', function (event) {

    //  var $thisSlide = $(this);
    //  var thisIndex = $thisSlide.attr('data-slick-index');
    //  var $thisParent = $thisSlide.closest('.section-slider ul');
    //  var activeSlides = $thisParent.find('.slick-active').length;
    //  var goToSlide = thisIndex - activeSlides - 1;

    //  $tabNavSlider.slick('slickGoTo', goToSlide);
    //});

    /*
      this.destroySlider($tabNavSlider);
    }
    */

  }

  //initSlider($selector, options) {
  //  if ($selector.length && !$selector.hasClass('slick-initialized')) {
  //    $selector.slick(options);
  //  }
  //}

  /*
  destroySlider($selector) {
    if ($selector.length && $selector.hasClass('slick-initialized')) {
      $selector.slick('unslick');
    }
  }
  */

  open(src): void {
    // open lightbox
    //var albums = [
    //  {
    //    src: src.replace("82-102", "original"),
    //    thumb: src
    //  }];

    //this._lightbox.open(albums, 0);
  }

  ngOnInit() {

    //since this is hard-coded and so can't be routed as "year" param from app-routing, this is a workaround
    //this.selectedYear = parseInt(this.route.snapshot.url[3].toString());

    //console.log("selectedYear", this.selectedYear);
    //console.log("route", this.route);
    //console.log("route.snapshot", this.route.snapshot);
    //console.log("route.queryParams", this.route.queryParams);
    //console.log("router", this.router);

    //this.route.queryParams.subscribe(params => {
    //  this.setQueryParams(params);
    //});

    this.route.params.subscribe(params => {
      this.setRouteArgs(params);
    });

    this.newVersionService.getWebProjectPath().toPromise().then(path => {
      this.webProjectPath = path;
    });
    //this.initSlick();
  }

  setRouteArgs(params) {

    if (params) {

      this.selectedYear = +params.year;

      this.listFriendlyUrl = params.listType;

      this.continentFriendlyUrl = params.continent;

      if (params.previewGuid != undefined) {
        this.previewGuid = params.previewGuid;
      }

      //console.log("NEW COMPONENT (V2); selectedYear", this.selectedYear);
      //console.log("route", this.route);
      //console.log("route.snapshot", this.route.snapshot);
      //console.log("route.queryParams", this.route.queryParams);
      //console.log("router", this.router);
    }

    //if (params !== undefined && params !== null && params.year !== undefined) {
    //  this.selectedYear = +params.year;

    //  this.listFriendlyUrl = params.listType;

    //  this.continentFriendlyUrl = params.continent;

    //  if (params.previewGuid != undefined) {
    //    this.previewGuid = params.previewGuid;
    //  }
    //}

    this.getContinent();
  }

  /*initSlick() {

    var $slickElement = $('.slider__slides');

    if ($slickElement) {

      var $slideCount = $('.slideCount');
      var $currentSlideIndex = $('.currentSlide');

      //console.log("about to initialise $slickElement=,$slideCount=,$currentSlideIndex=", $slickElement, $slideCount, $currentSlideIndex);

      $slickElement.on('init reInit afterChange', function (event, slick, currentSlide, nextSlide) {
        //currentSlide is undefined on init -- set it to 0 in this case (currentSlide is 0 based)
        var i = (currentSlide ? currentSlide : 0) + 1;
        $currentSlideIndex.text(i);
        $slideCount.text(' / ' + slick.slideCount);
      });

      $slickElement.slick({
        dots: false,
        infinite: true,
        slidesToShow: 1,
        arrows: true,
        adaptiveHeight: true,
        responsive: [
          {
            breakpoint: 768,
            settings: {
              slidesToShow: 1,
              infinite: true,
              dots: false
            }
          },
        ]
      });

    }

  }*/

  //setQueryParams(params) {

  //  if (params['sort'] !== undefined && params['sort'] !== null) {
  //    var sort = params["sort"];
  //    if (sort == 'city') {
  //      this.selectedSortByFilter = 9;
  //    }
  //    else {
  //      var filter = this.sortByFilter.filter((o) => {
  //        return (o.urlValue == sort);
  //      })[0]

  //      if (!filter) {
  //        this.selectedSortByFilter = 10;
  //      }
  //      else {
  //        this.selectedSortByFilter = filter.value;
  //      }      
  //    }

  //  }

  //  if (params["sortByDir"] !== undefined && params['sortByDir'] !== null) {    
  //    this.sortByDirection == params["sortByDir"];
  //  }

  ////  if (params["view"] !== undefined && params['sort'] !== null) {
  ////    var type = params["view"];
  ////    if (type === 'list') {
  ////      $('.tabs__sort-view .list').closest('.tabs').find('.tab').addClass('list-view');
  ////      $('.list-filters').removeClass('hidden');
  ////    }      
  ////  }
  ////  else {
  ////    $('.tabs__sort-view .list').closest('.tabs').find('.tab').removeClass('list-view');
  ////    $('.list-filters').addClass('hidden');
  ////  }
  //}

  viewChanged(type) {
    this.router.navigate(['/lists/' + this.continentFriendlyUrl + '/' + this.listFriendlyUrl + '/' + this.selectedYear],
      {
        queryParams: {
          view: type === 'list' ? type : null
        }, queryParamsHandling: 'merge'
      });
  }

  getContinent() {
    this._http.get("continent/getbyfriendlyurl/" + this.continentFriendlyUrl).toPromise().then((data) => {
      this.continent = data.json();
      //if (this.continent.name == "North America") {
      //  this.sortByFilter.push(
      //    { value: 8, displayName: "State", urlValue: 'state' },
      //  );
      //}

      this.getListType();
    }).catch();
  }


  getListType() {
    this._http.get("lists/GetListTypeByListFriendlyUrl/" + this.listFriendlyUrl).toPromise().then((data) => {
      this.listType = data.json();
      this.getLanguages();
      this.getLists();
    }).catch();
  }

  onLanguageChange(languageId) {

    //this.router.navigate(['/lists/' + this.continentFriendlyUrl + '/' + this.listFriendlyUrl + '/' + this.selectedYear],
    //  {
    //    queryParams: {
    //      lang: languageId
    //    }, queryParamsHandling: 'merge'
    //  });


    window.location.href = window.location.pathname + "?lang=" + languageId;
  }

  getLists() {
    this.lists = null;

    this._http.get("/lists/getpublishedtypesbycontinent/" + this.continent.id).toPromise().then((data) => {

      this.listTypes = data.json().filter((x) => {
        return x.isSpeciality === this.listType.isSpeciality
      });

    });

    this._http.get("lists/getAllByContinentIdAndSpeciality/" + this.continent.id + "/" + this.listType.isSpeciality).toPromise().then((data) => {
      this.lists = data.json();
      this.selectedListId = 0;

      //console.log("this.lists=", this.lists);

      var filteredList = this.lists.filter((o) => {
        return (o.year == this.selectedYear && o.continentId == this.continent.id
          && o.listTypeId == this.listType.id);
      });

      //console.log("filteredList", filteredList);

      var listsWithinContinentAndType = this.lists.filter((o) => {
        return (o.continentId == this.continent.id
          && o.listTypeId == this.listType.id && o.isPublished);
      });

      //console.log("listsWithinContinentAndType", listsWithinContinentAndType);

      if (listsWithinContinentAndType.length > 1) {
        this.yearFilter = [];
        for (var i = 0; i < listsWithinContinentAndType.length; i++) {
          this.yearFilter.push({ value: listsWithinContinentAndType[i].year, name: listsWithinContinentAndType[i].year.toString() });
        }

        this.yearFilter = this.yearFilter.sort((obj1, obj2) => {
          if (obj1.value > obj2.value) {
            return -1;
          }
          if (obj1.value < obj2.value) {
            return 1;
          }
          return 0;
        });
      }

      if (filteredList !== undefined && filteredList[0] !== undefined) {
        this.selectedListId = filteredList[0].id;
        this.selectedList = filteredList[0];

        //console.log("this.selectedList=", this.selectedList);
      }

      this.getListRestaurants(this.selectedListId);

      setTimeout(() => {
        this.onResize(null);
      }, 5);
    }).catch();
  }

  getLanguages() {
    this._http.get("/languages").toPromise().then((data) => {
      this.languages = data.json();
      this.selectedLanguage = this.languages.find((x) => { return x.selected; });
    });
  }

  onYearFilterChange(value) {
    this.selectedYear = value;
    //this.getListRestaurants(this.selectedListId);
    this.router.navigate(['/lists/' + this.continentFriendlyUrl + '/' + this.listFriendlyUrl + '/' + this.selectedYear]);
  }

  onSortByChange(listRankTypeIndex: number, value) {

    this.selectedSortByFilter[listRankTypeIndex] = value;

    if ($(".sortClose").is(":visible")) {
      $(".sortClose").click();
    }

    var url = '/lists/' + this.continentFriendlyUrl + '/' + this.listFriendlyUrl + '/' + this.selectedYear;

    if (this.previewGuid != undefined && this.previewGuid != null) {
      url += "/" + this.previewGuid.toString();
    }


    //this.router.navigate([url],
    //  {
    //    queryParams: {
    //      sort: this.sortByFilter.filter((o) => {
    //        return (o.value == this.selectedSortByFilter);
    //      })[0].urlValue,
    //      sortByDir: this.sortByDirection === "ASC" ? null : this.sortByDirection
    //    }, queryParamsHandling: 'merge'
    //  });


    this.sort(listRankTypeIndex);
  }

  sort(listRankTypeIndex: number) {

    var list = this.listRestaurants0;

    switch (listRankTypeIndex) {

      case 1:
        list = this.listRestaurants1;
        break;

      case 2:
        list = this.listRestaurants2;
        break;

      case 3:
        list = this.listRestaurants3;
        break;
    }

    //rank (in fact, let's use display order as returned originally from SP - the reason being, HR's and R's may have a certain ranking, but we're overriding
    //it via search by grouping by country>city>name in each group regardless of a potential value of rank)
    if (this.selectedSortByFilter[listRankTypeIndex] == 1) {

      //console.log("sorting by rank..");

      list = list.sort((obj1, obj2) => {

        if (obj1.displayOrder > obj2.displayOrder) {
          return 1;
        }
        if (obj1.displayOrder < obj2.displayOrder) {
          return -1;
        }
        return 0;
      });
    }

    //name
    if (this.selectedSortByFilter[listRankTypeIndex] == 2) {

      //console.log("sorting by name..");

      list = list.sort((obj1, obj2) => {
        if (obj1.name > obj2.name) {
          return 1;
        }
        if (obj1.name < obj2.name) {
          return -1;
        }
        return 0;
      });
    }

    //chef
    if (this.selectedSortByFilter[listRankTypeIndex] == 3) {
      list = list.sort((obj1, obj2) => {
        if (obj1.chef > obj2.chef) {
          return 1;
        }
        if (obj1.chef < obj2.chef) {
          return -1;
        }
        return 0;
      });
    }

    //cuisine
    if (this.selectedSortByFilter[listRankTypeIndex] == 4) {
      list = list.sort((obj1, obj2) => {
        if (obj1.cuisine > obj2.cuisine) {
          return 1;
        }
        if (obj1.cuisine < obj2.cuisine) {
          return -1;
        }
        return 0;
      });
    }

    //city
    if (this.selectedSortByFilter[listRankTypeIndex] == 6) {
      list = list.sort((obj1, obj2) => {
        if (obj1.city > obj2.city) {
          return 1;
        }
        if (obj1.city < obj2.city) {
          return -1;
        }

        if (obj1.rank > obj2.rank) {
          return 1;
        }
        if (obj1.rank < obj2.rank) {
          return -1;
        }
        return 0;
      });
    }

    //country
    if (this.selectedSortByFilter[listRankTypeIndex] == 7 || this.selectedSortByFilter[listRankTypeIndex] == 5) {
      list = list.sort((obj1, obj2) => {
        if (obj1.country > obj2.country) {
          return 1;
        }
        if (obj1.country < obj2.country) {
          return -1;
        }

        if (obj1.state > obj2.state) {
          return 1;
        }
        if (obj1.state < obj2.state) {
          return -1;
        }

        if (obj1.city > obj2.city) {
          return 1;
        }
        if (obj1.city < obj2.city) {
          return -1;
        }

        if (obj1.rank > obj2.rank) {
          return 1;
        }
        if (obj1.rank < obj2.rank) {
          return -1;
        }

        return 0;
      });
    }


    //region
    if (this.selectedSortByFilter[listRankTypeIndex] == 8) {
      list = list.sort((obj1, obj2) => {
        if (obj1.state > obj2.state) {
          return 1;
        }
        if (obj1.state < obj2.state) {
          return -1;
        }

        if (obj1.rank > obj2.rank) {
          return 1;
        }
        if (obj1.rank < obj2.rank) {
          return -1;
        }
        return 0;
      });
    }


    //location1
    if (this.selectedSortByFilter[listRankTypeIndex] == 9) {
      list = list.sort((obj1, obj2) => {
        if (obj1.location1 > obj2.location1) {
          return 1;
        }
        if (obj1.location1 < obj2.location1) {
          return -1;
        }

        if (obj1.rank > obj2.rank) {
          return 1;
        }
        if (obj1.rank < obj2.rank) {
          return -1;
        }
        return 0;
      });
    }

    //location2
    if (this.selectedSortByFilter[listRankTypeIndex] == 10) {
      list = list.sort((obj1, obj2) => {
        if (obj1.location2 > obj2.location2) {
          return 1;
        }
        if (obj1.location2 < obj2.location2) {
          return -1;
        }

        if (obj1.rank > obj2.rank) {
          return 1;
        }
        if (obj1.rank < obj2.rank) {
          return -1;
        }
        return 0;
      });
    }
  }

  listTypeChange(friendlyUrl) {
    this.listFriendlyUrl = friendlyUrl;
    this.router.navigate(['/lists/' + this.continentFriendlyUrl + '/' + this.listFriendlyUrl + '/' + this.selectedYear]);
  }

  getListRestaurants(id) {

    this.selectedListId = id;
    this.listRestaurants0 = null;
    this.listRestaurants1 = null;
    this.listRestaurants2 = null;
    this.listRestaurants3 = null;

    var postData = {
      ListId: this.selectedListId,
      Year: this.selectedYear,
      SortByDirection: this.sortByDirection,
      SortBy: this.selectedSortByFilter[0],
      PreviewGuid: this.previewGuid
    }

    if (this.selectedListId !== 0) {
      this._http.post("/lists/getrestaurantsbylistIdAndYear", JSON.stringify(postData), { headers: new Headers({ 'Content-Type': 'application/json' }) }).toPromise()
        .then((data) => {
          this.data = data.json();
          this.listRestaurants0 = this.data.data0;
          this.listRestaurants1 = this.data.data1;
          this.listRestaurants2 = this.data.data2;
          this.listRestaurants3 = this.data.data3;

          this.sortByFilter.push(
            { value: 9, displayName: this.data.location1, urlValue: this.data.location1.replace(" ", "").replace(" ", "").replace("/", "-").toLowerCase() },
            { value: 10, displayName: this.data.location2, urlValue: this.data.location2.replace(" ", "").replace(" ", "").replace("/", "-").toLowerCase() },
          );
        }).catch();
    }
    else {
      this.listRestaurants0 = [];
      this.listRestaurants1 = [];
      this.listRestaurants2 = [];
      this.listRestaurants3 = [];
    }
  }

  getLegacyRestaurant() {
    if (this.listRestaurants3 && this.listRestaurants3.length == 1) {
      this.legacyRestaurant = this.listRestaurants3[0];
    }
    else {
      this.legacyRestaurant = null;
    }
    return this.legacyRestaurant;
  }

  getRestaurantUrl(friendlyUrl: string): string {
    //return `${this.webProjectPath}restaurant/${friendlyUrl}`;
    return `/restaurant/${friendlyUrl}`;
  }

  toggleFilters() {
    this.isFiltersShown = !this.isFiltersShown;
  }

  onFilterSubmit() {
    if (!this.originalListRestaurants0) {
      this.originalListRestaurants0 = [...this.listRestaurants0];
    }

    this.listRestaurants0 = this.originalListRestaurants0.filter(item => {
      return (!this.filterValues.name || item.name.toLowerCase().includes(this.filterValues.name.toLowerCase()))
        && (!this.filterValues.chef || item.chef.toLowerCase().includes(this.filterValues.chef.toLowerCase()))
        && (!this.filterValues.cuisine || item.cuisine.toLowerCase().includes(this.filterValues.cuisine.toLowerCase()))
        && (!this.filterValues.location1 || item.location1.toLowerCase().includes(this.filterValues.location1.toLowerCase()))
        && (!this.filterValues.location2 || item.location2.toLowerCase().includes(this.filterValues.location2.toLowerCase()));
    });
  }
}
